import TagManager from "react-gtm-module";

import { googleTagManagerKey, isGoogleTagManagerEnabled } from "./env.helpers";
import { Log } from "./log.helpers";

export class GTM {
  gtmId: string | undefined = googleTagManagerKey();
  isGTMEnabled: boolean = isGoogleTagManagerEnabled();
  wasInit = false;

  init(): void {
    let op = "skipped";

    if (!this.wasInit && this.gtmId && this.isGTMEnabled) {
      op = "initialized";
      TagManager.initialize({ gtmId: this.gtmId });
      this.wasInit = true;
    }

    Log.debug(`[GTM] [Init] - GTM was ${op}`);
  }
}

export const gtm = new GTM();
